<!-- Mobile / (< large - 998px ) - First/Fixed row -->
<nav class="navbar fixed-top d-lg-none p-0 shadow-sm" aria-label="navbartopmenufixed">
  <span class="nav-item col d-flex flex-column align-items-center c-pointer" (click)="mobileNavMenuCollapseShow = !mobileNavMenuCollapseShow" (clickOutside)="mobileNavMenuCollapseShow = false">
    <i class="bi bi-list"></i>
    <span i18n="@@NavTopMenuMenu">Menu</span>
  </span>

  <div class="nav-item col d-flex justify-content-center c-pointer">
    <a class="d-contents" [routerLink]="brandPage.routerlink" [queryParams]="brandPage.queryParams">
      <img role="img" class="brand-logo" alt="Logo" />
      <span class="brand-name">{{ brand }}</span>
    </a>
  </div>

  @if (isAuthenticated == true && isShoppingCartButtonVisible == true) {
    <span class="nav-item col d-flex flex-column align-items-center c-pointer" data-bs-target="#stickyFooterCartPreviewOffCanvas" data-bs-toggle="offcanvas">
      <span class="cart-container">
        <i class="bi bi-cart4"></i>
        <span>{{ shoppingCartItemCount }}</span>
      </span>
    </span>
  }
  @if (isAuthenticated == true && isShoppingCartButtonVisible == false) {
    <span class="nav-item col d-flex flex-column align-items-center">
      <span class="cart-container">
        <i class="bi bi-cart4"></i>
        <i class="bi bi-x-lg" style="color: red; position: absolute"></i>
      </span>
    </span>
  }

  @if (isAuthenticated == false) {
    <div class="nav-item col d-flex flex-column justify-content-center align-items-center c-pointer" [routerLink]="['/login']">
      <i class="bi bi-person"></i>
      <span class="ms-1" i18n="@@NavTopMenuLogin">Login</span>
    </div>
  }

  <ng-container *ngTemplateOutlet="mobileNavMenuToggle"></ng-container>
</nav>

<!-- Mobile / (< large - 998px ) - Second/Floating row -->
<nav class="navbar floating-top d-lg-none pb-0" aria-label="navbartopmenu">
  @if (isAuthenticated == true) {
    <div class="row w-100">
      @if (isMyShopButtonVisibile == true) {
        <div class="col-4 d-flex justify-content-center align-items-end">
          <app-my-shop-toggle-button></app-my-shop-toggle-button>
        </div>
      }
      @if (isMyShopButtonVisibile == false) {
        <div class="col-4 d-flex justify-content-center align-items-end"></div>
      }
      <div class="col-4 d-flex flex-column justify-content-center align-items-center c-pointer" [routerLink]="['/shopping-cart', 'management']">
        <i class="bi bi-card-list"></i>
        <span class="text-nowrap" i18n="@@NavTopMenuCartManagement">Shopping lists</span>
      </div>
      <div class="col-4 d-flex flex-column justify-content-center align-items-center c-pointer" data-bs-toggle="offcanvas" data-bs-target="#sidebar-user">
        <i class="bi bi-person"></i>
        @if (userName != undefined) {
          <span class="ms-1"> {{ userName | usernameAbbreviation }}</span>
        }
        @if (userName == undefined) {
          <span class="ms-1" i18n="@@NavTopMenuUserName">User</span>
        }
      </div>
    </div>
  }
</nav>

<!-- Desktop / (> large - 998px ) -->
<nav class="navbar navbar-expand-lg d-none d-lg-block shadow-sm" aria-label="navbartopmenu">
  <div class="container">
    <a class="d-contents" [routerLink]="brandPage.routerlink" [queryParams]="brandPage.queryParams">
      <img role="img" class="brand-logo" alt="Logo" />
      <span class="brand-name">{{ brand }}</span>
    </a>

    <ng-container *ngTemplateOutlet="searchBar"></ng-container>

    <div>
      <span class="d-flex justify-content-end small">
        @if (isAuthenticated == true) {
          <span class="nav-item d-flex flex-column justify-content-center align-items-center text-center c-pointer" [routerLink]="['/shopping-cart', 'management']">
            <i class="bi bi-card-list"></i>
            <span class="text-nowrap" i18n="@@NavTopMenuCartManagement">Shopping lists</span>
          </span>
        }

        @if (isAuthenticated == false) {
          <div class="nav-item d-flex flex-column justify-content-center align-items-center mt-auto c-pointer">
            <span class="c-pointer text-nowrap" [class.active]="activeComponent != undefined && activeComponent.indexOf('/register') >= 0" [routerLink]="['/register']" i18n="@@NavTopMenuRegister">Register</span>
          </div>
          <div class="nav-item d-flex flex-column justify-content-center align-items-center c-pointer" [class.active]="activeComponent != undefined && activeComponent.indexOf('/login') >= 0" [routerLink]="['/login']">
            <i class="bi bi-person"></i>
            <span class="ms-1" i18n="@@NavTopMenuLogin">Login</span>
          </div>
        }

        @if (isAuthenticated == true) {
          <div class="nav-item d-flex flex-column justify-content-center align-items-center c-pointer" data-bs-toggle="offcanvas" data-bs-target="#sidebar-user">
            <i class="bi bi-person"></i>
            @if (userName != undefined) {
              <span class="ms-1"> {{ userName | usernameAbbreviation }}</span>
            }
            @if (userName == undefined) {
              <span class="ms-1" i18n="@@NavTopMenuUserName">User</span>
            }
          </div>
          @if (isShoppingCartButtonVisible == true) {
            <span class="d-xxl-none nav-item d-flex flex-column justify-content-center align-items-center c-pointer me-4" data-bs-target="#stickyFooterCartPreviewOffCanvas" data-bs-toggle="offcanvas">
              <span class="cart-container">
                <i class="bi bi-cart4"></i>
                <span>{{ shoppingCartItemCount }}</span>
              </span>
            </span>
          }
          @if (isShoppingCartButtonVisible == false) {
            <span class="d-xxl-none nav-item d-flex flex-column justify-content-center align-items-center c-pointer me-4" data-bs-target="#stickyFooterCartPreviewOffCanvas" data-bs-toggle="offcanvas">
              <span class="cart-container">
                <i class="bi bi-cart4"></i>
                <i class="bi bi-x-lg" style="color: red; position: absolute"></i>
              </span>
            </span>
          }
          <span class="nav-item d-flex flex-column justify-content-center align-items-center">
            <span class="c-pointer" [class.active]="activeComponent != undefined && activeComponent.indexOf('/user') >= 0" [routerLink]="['/user']">
              <i class="bi bi-gear"></i>
            </span>
            <span class="c-pointer" (click)="logout()">
              <i class="bi bi-power"></i>
            </span>
          </span>
        }
      </span>
    </div>
  </div>
</nav>

<app-category-nav-bar></app-category-nav-bar>

<ng-template #searchBar>
  <span class="dropdown w-100 mx-4">
    <!-- Search bar -->
    <div class="input-group">
      <input
        #searchInput
        type="text"
        class="form-control dropdown h-100"
        i18n-placeholder="@@NavTopMenuSearchPlaceholder"
        placeholder="Search"
        aria-label="Search"
        autocomplete="off"
        [ngModel]="searchText"
        name="searchText"
        (input)="searchTextKeypress($event)"
        (focus)="searchInputFocused = true"
        (blur)="searchInputFocused = false"
        (keydown)="navigateUsingKey($event)"
        (click)="searchInputFocused = true"
      />

      <button class="input-group-text py-0 px-3" id="navbartopmenusearch" (click)="productSearch()">
        <i class="bi bi-search"></i>
      </button>
    </div>

    <!-- Search results / preview -->
    @if (searchPreviewItemList && searchInputFocused) {
      <ul class="search-preview-container dropdown-menu show w-100 p-2 position-absolute">
        <li class="search-preview dropdown-item c-pointer p-0" (mousedown)="$event.preventDefault()" (mouseenter)="linkedIndexSet(-1)" (click)="productSearch()" [class.selected-search-preview-item]="-1 === linkIndex">
          <span i18n="@@NavTopSearchPreviewCountPrefix">Found</span>
          <span> {{ searchPreviewItemList.length }} </span>
          <span i18n="@@NavTopSearchPreviewCoundtSuffix">products</span>
          @if (searchPreviewItemList.length > searchPreviewMaxCount) {
            <span> ...</span>
          }
        </li>
        @if (searchPreviewItemListSlice) {
          <hr class="dropdown-divider mx-0 my-1" />
          @for (searchPreviewEntry of searchPreviewItemListSlice; track searchPreviewEntry; let i = $index) {
            <li class="search-preview dropdown-item c-pointer p-0" [class.selected-search-preview-item]="i === linkIndex" (mouseenter)="linkedIndexSet(i)">
              <app-search-preview-item [searchPreviewItem]="searchPreviewEntry" (onProductSearchResultClicked)="onProductSearchResultClick(searchPreviewEntry)"> </app-search-preview-item>
            </li>
          }
          @if (searchPreviewItemList.length > searchPreviewMaxCount) {
            <hr class="dropdown-divider mx-0 my-1" />
            <li
              class="search-preview dropdown-item c-pointer p-0"
              (mousedown)="$event.preventDefault()"
              (click)="productSearch()"
              (mouseenter)="linkedIndexSet(searchPreviewItemListSlice.length)"
              [class.selected-search-preview-item]="searchPreviewItemListSlice.length === linkIndex"
            >
              <span>...</span>
            </li>
          }
        }
      </ul>
    }
  </span>
</ng-template>

<ng-template #mobileNavMenuToggle>
  @if (mobileNavMenuCollapseShow) {
    <div #mobileNavMenuCollapse class="collapse navbar-collapse show" id="mobileNavMenuCollapse">
      <ul class="navbar-nav">
        @if (isAuthenticated == false) {
          <li class="nav-item light" [routerLink]="['/login']">
            <span class="d-flex align-items-center">
              <i class="bi bi-person"></i>
              <span i18n="@@NavTopMenuMobileLogin">Login</span>
            </span>
          </li>
          <li class="nav-item" [routerLink]="['/register']">
            <a class="nav-link" i18n="@@NavTopMenuRegister">Register</a>
          </li>
          <li class="nav-item" [routerLink]="['/content']" [queryParams]="{ parent: 'About' }">
            <a class="nav-link" i18n="@@NavTopMenuAboutLink">About</a>
          </li>
          <li class="nav-item" [routerLink]="['/contact-request']">
            <a class="nav-link" i18n="@@NavTopMenuContactRequestLink">Contact</a>
          </li>
        }
        @if (isAuthenticated == true) {
          <li class="nav-item light d-flex">
            <span class="d-flex align-items-center w-100" data-bs-toggle="offcanvas" data-bs-target="#sidebar-user">
              <i class="bi bi-person"></i>
              @if (userName != undefined) {
                <span class="ms-1"> {{ userName | usernameAbbreviation }}</span>
              }
            </span>
            <span class="ms-auto"></span>
            <span (click)="logout()">
              <i class="bi bi-power"></i>
            </span>
          </li>
          <li class="nav-item" [routerLink]="['/user']">
            <a class="nav-link" i18n="@@NavTopMenuAcoountLink">My Account</a>
          </li>
          <li hidden class="nav-item" [routerLink]="['/content']" [queryParams]="{ parent: 'About' }">
            <a class="nav-link" i18n="@@NavTopMenuAboutLink">About</a>
          </li>
          <li class="nav-item" [routerLink]="['/contact-request']">
            <a class="nav-link" i18n="@@NavTopMenuContactRequestLink">Contact</a>
          </li>
          <li hidden class="nav-item">
            <a class="nav-link">Newsletter?</a>
          </li>
        }
      </ul>
    </div>
  }
</ng-template>
